<template>
    <v-card flat class="purchase__order_card pa-4">
        <template v-slot:title>
            <span class="font-weight-black">Resumen de compra</span>
        </template>
        <v-container class="content_card px-5">
            <v-row>
                <div class="custom__hr"></div>
            </v-row>
            <!-- detalle -->
            <v-row>
                <span>{{ item.name }} {{ `(${ count })` }}</span>
                <v-spacer></v-spacer>
                <span>{{ formatCurrency(item.price) }}</span>
            </v-row>

            <!-- total -->
             <div class="mt-7">
                <v-row>
                    <strong>Total</strong>
                    <v-spacer></v-spacer>
                    <strong>{{ `${ total }` }}</strong>
                </v-row>
             </div>
            
            <v-row>
                <v-btn 
                    @click="continueAction" 
                    class="mt-7 text-none font-weight-bold" 
                    block 
                    color="primary"
                    :loading="loading"
                    :disabled="loading"
                >
                    {{ textButton }}
                </v-btn>
            </v-row>
        </v-container>
    </v-card>
    <v-dialog v-model="showStatusModal" max-width="550">
        <v-card class="rounded-xl" style="line-height: normal;">
            <v-card-title class="headline text-center font-weight-bold text-h6">
                <v-img
                    :src="require('@/assets/warning.png')"
                    contain
                    max-width="100"
                    class="mx-auto mb-4"
                />
                <strong class="header-label">Retraso en la emisión de tu informe <br>financiero</strong>
            </v-card-title>

            <v-card-text style="text-align: center;">
            <label style="font-size:14px;letter-spacing: 0;">
                Actualmente, 
                algunos de los servicios externos que consultamos para generar tu informe están experimentando intermitencias, 
                lo que ha afectado su emisión.<br> Lamentamos los inconvenientes  y estamos monitoreando la situación de cerca.
            </label>
            </v-card-text>
            <!---->
            <v-card-text class="info-box">
                <v-icon class="info-icon">mdi-information</v-icon>
                <span class="info-text">
                    <strong style="font-size:14px;font-weight:700;letter-spacing: 0;">
                        Si decides continuar con la compra, te enviaremos el informe automáticamente a tu correo en cuanto el servicio se restablezca.
                        De lo contrario, puedes intentarlo nuevamente más tarde. 
                    </strong>
                </span>
            </v-card-text>
            <!---->
            <v-card-text style="text-align: center;">
                <label style="font-size:14px;font-weight:400;letter-spacing: 0;">
                    Te notificaremos cuando todos los servicios estén operando correctamente. <br> Agradecemos tu comprensión.
                </label>
            </v-card-text>
            <v-card-actions class="justify-center">
            <v-btn @click="goToUrl" class="modal_button mb-3 text-none font-weight-bold" variant="outlined" color="primary">
                Cancelar compra
            </v-btn>
            <v-btn @click="continuePayment" class="modal_button mb-3 text-none font-weight-bold" variant="flat" color="primary">
                Pagar ahora
            </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import api from '@/api';
import { formatCurrency } from '@/helpers/utils';
import { mapGetters,  } from 'vuex';

export default {
    name:'purchase-order',
    data(){
        return {
            showStatusModal: false,
        };
    },
    computed: {
        ...mapGetters('cart', ['item', 'count', 'total', 'step', 'formStepTwo']),
        ...mapGetters('payment', ['customerInfo', 'loading']),
        ...mapGetters('alert', ['getAlert']),
        textButton() {
            switch (this.step) {
                case 1:
                    return 'Continuar compra';
                case 2:
                    return 'Continuar';
                case 3: 
                    return 'Pagar ahora';
                default:
                    return 'Continuar';
            }
        }
    },
    methods: {
        formatCurrency(value) {
            return formatCurrency(value);
        },
        async continueAction(){
            const isPaymentStep = this.step === 3;
            const isFormStep = this.step === 2;

            if (isFormStep) {
                if (this.formStepTwo.isValid) {
                    if(this.customerInfo.autocomplete){
                        const data =  await this.verificarUsuario();
                        if(! data ) return;
                    }

                    this.$store.dispatch('cart/nextStep');

                } else {
                    this.$store.dispatch('cart/updateSubmittedForm', true);
                }
            } else if (isPaymentStep) {       
                const payload = {
                    name: this.customerInfo.name,
                    lastname: this.customerInfo.lastname,
                    rut: this.customerInfo.rut,
                    email: this.customerInfo.email,
                    telefono: this.customerInfo.telefono,
                    tipo_informe: this.item.id,
                    monto_compra: this.count * this.item.price,
                    cant_informes: this.count
                }
                let status = await this.verifyServicesStatus(payload);
                
                if(status){
                    this.handlePayment(payload);
                    api.DoSetSendServices(payload, this.getAlert);
                }
            } else {
                this.$store.dispatch('cart/nextStep');
            }
        },
        async handlePayment(payload) {
            this.$store.dispatch('payment/handleLoading', true);

            try {
                const { status, url, token } = await this.$store.dispatch('payment/startPayment', payload);

                if (status === 1 && url) {
                    // Abre una nueva ventana para el pago
                    const paymentWindow = window.open(url, '_blank'); // deberia manejar esto en el store ?? podria ser, para crear una nueva orden de compra

                    const pollInterval = setInterval(async () => {
                        try {
                            const { status, payment_desc } = await this.$store.dispatch('payment/checkStatus', token);
                            if (paymentWindow.closed && status == 1 && payment_desc == 'pendiente') {
                                clearInterval(pollInterval);
                                this.$store.dispatch('snackbar/showSnack', { text: 'El pago no se ha procesado', type: 'error' });
                                this.$store.dispatch('payment/handleLoading', false);
                                
                                await this.$store.dispatch('payment/startCancelPayment');
                                return;
                            }
    
                            else if(status == 2){
                                clearInterval(pollInterval);
                                setTimeout(() => {
                                    paymentWindow.close();
                                    this.$store.dispatch('payment/handleLoading', false);
                                    this.$store.dispatch('cart/nextStep');
                                }, 2000);
    
                            }
                            else if(status == 3){
                                clearInterval(pollInterval);
                                paymentWindow.close();
                                this.$store.dispatch('payment/handleLoading', false);
                                this.$store.dispatch('snackbar/showSnack', { text: 'Ha ocurrido un error al procesar el pago', type: 'error' });
                            }
                        } catch (error) {
                            this.$store.dispatch('payment/handleLoading', false);
                            console.error('Error al verificar el estado del pago:', error);
                        }
                       
                    }, 5000); 
                } else {
                    console.error('Error en el estado del pago:', status);
                    this.$store.dispatch('payment/handleLoading', false);
                }
            } catch (error) {
                console.error('Error en el proceso de pago:', error);
                this.$store.dispatch('payment/handleLoading', false);
                this.$store.dispatch('snackbar/showSnack', { text: 'Ha ocurrido un error al procesar el pago', type: 'error' });
            }
        },
        async verificarUsuario(){
            this.$store.dispatch('payment/handleLoading', true);

            const payload = {
                rut: this.customerInfo.rut,
                email: this.customerInfo.email,
            }

            try {
                const { status } = await api.verificarUsuario(payload); 
                
                if(status === 1){
                    return true;
                }
                
            } catch (error) {
                const errorMessage = error.message;
                this.$store.dispatch('snackbar/showSnack', { text: errorMessage, type: 'error' });
                return false;
                
            }finally{
                this.$store.dispatch('payment/handleLoading', false);
            }
        },
        async verifyServicesStatus(payload){

            try {
                await this.$store.dispatch('alert/changeState', payload);
                if(! this.getAlert ) {
                    this.showStatusModal = true;
                }
                return this.getAlert;
            } catch (error) {
                console.error(error);
            }
        },
        goToUrl() {
            const payload = {
                name: this.customerInfo.name,
                lastname: this.customerInfo.lastname,
                rut: this.customerInfo.rut,
                email: this.customerInfo.email,
                telefono: this.customerInfo.telefono,
                tipo_informe: this.item.id,
                monto_compra: this.count * this.item.price,
                cant_informes: this.count
            }
            api.DoSetSendServices(payload, this.getAlert);
            window.location.href = 'https://www.checkempresa.cl';
        },
        continuePayment(){
            const payload = {
                name: this.customerInfo.name,
                lastname: this.customerInfo.lastname,
                rut: this.customerInfo.rut,
                email: this.customerInfo.email,
                telefono: this.customerInfo.telefono,
                tipo_informe: this.item.id,
                monto_compra: this.count * this.item.price,
                cant_informes: this.count
            }
            this.handlePayment(payload);
            this.showStatusModal = false;
        }

    }
}
</script>
<style scoped lang="scss">
    .header-label{
        font-size:18px;
        font-weight: 700;
        font-family:'inter';
    }
    
    .info-box {
        display: flex;
        align-items: center;
        border: 1px solid #004CDD;        
        background-color: #D3E1FD;        
        border-radius: 8px;               
        padding: 16px;
        color: #004CDD;                   
        width:90%;
        margin-left:4%;    
    }

    .info-icon {
        font-size: 24px;
        margin-right: 12px;
        color: #004CDD;                  
    }

    .info-text {
        font-size: 16px;
        font-weight: 500;
    }

    .modal_button {
        font-size:16px;
    }
</style>
